"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var CrudService_1 = __importDefault(require("../../Core/CrudService"));
var entityName = 'service_areas';
var ServiceAreaService = /** @class */ (function () {
    function ServiceAreaService(session) {
        this.service = new CrudService_1.default(session, entityName);
    }
    ServiceAreaService.prototype.loadAll = function (commonOptions) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator
                            .get("/".concat(this.service.entityName))
                            .withCommonOptions(commonOptions)
                            .setException('Failed to get all service areas')
                            .invoke()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.service_areas];
                }
            });
        });
    };
    ServiceAreaService.prototype.loadAllByTeams = function (request, commonOptions) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        // Not requesting with empty/non valid teams_ids as the API will return all the service areas the user have access to
                        if ((_a = request.teams_ids) === null || _a === void 0 ? void 0 : _a.every(function (id) { return id == null; })) {
                            // eslint-disable-next-line no-console
                            console.warn('Teams ids are empty, please use loadAll instead', __assign({}, request));
                            return [2 /*return*/, []];
                        }
                        return [4 /*yield*/, this.service.routeGenerator
                                .get("/".concat(this.service.entityName))
                                .withQueryString(request)
                                .withCommonOptions(commonOptions)
                                .setException("Failed to get all service areas by team ids, ".concat(this.service.entityName, ", teams_ids: ").concat(request.teams_ids))
                                .invoke()];
                    case 1:
                        result = _b.sent();
                        return [2 /*return*/, result.service_areas];
                }
            });
        });
    };
    ServiceAreaService.prototype.create = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.create(request)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.service_area];
                }
            });
        });
    };
    ServiceAreaService.prototype.update = function (id, request) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.update(id, request)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.service_area];
                }
            });
        });
    };
    ServiceAreaService.prototype.delete = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.service.delete(id)];
            });
        });
    };
    ServiceAreaService.prototype.assign = function (id, userId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.service.routeGenerator
                        .put("/".concat(this.service.entityName, "/").concat(id, "/assign"))
                        .withRouteParams({ id: id })
                        .withPayload({ user_id: userId })
                        .invoke()];
            });
        });
    };
    ServiceAreaService.prototype.unassign = function (userId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.service.routeGenerator
                        .put("/".concat(this.service.entityName, "/unassign_user"))
                        .withPayload({ user_id: userId })
                        .invoke()];
            });
        });
    };
    ServiceAreaService.prototype.getAllByFields = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.service.routeGenerator.post("/".concat(this.service.entityName, "/fields")).withPayload(request).invoke()];
            });
        });
    };
    return ServiceAreaService;
}());
exports.default = ServiceAreaService;
//# sourceMappingURL=service-area-service.js.map